import React from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import './last-update.scss';
var LastUpdate = function (props) {
    var label = props.label, lastUpdate = props.lastUpdate;
    var t = useTranslation().t;
    return (React.createElement("p", { className: "last-update-container" },
        React.createElement("span", null,
            label,
            ": "),
        React.createElement("span", { "ng-if": "lastUpdate" }, lastUpdate ? moment(lastUpdate).format("lll Z") : "N/A")));
};
export default LastUpdate;
